import Vue from 'vue'

export default {
  state: {
    user: null,
    accessToken: null,
    smsCodeToken: null,
    userList: null,
    userTotalCount: 0,
    userSingle: null,
    pointLogistics: 0,
    pointSecurity: 0,
    userListActionId: 0
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    },
    setAccessToken (state, payload) {
      state.accessToken = payload
    },
    setSmsCodeToken (state, payload) {
      state.smsCodeToken = payload
    },
    setUserList (state, payload) {
      if (payload.userListActionId === state.userListActionId) {
        state.userList = payload.data
      }
    },
    setUserTotalCount (state, payload) {
      if (payload.userListActionId === state.userListActionId) {
        state.userTotalCount = payload.data
      }
    },
    setUserSingle (state, payload) {
      state.userSingle = payload
    },
    setPointLogistics (state, payload) {
      state.pointLogistics = payload
    },
    setPointSecurity (state, payload) {
      state.pointSecurity = payload
    },
    setUserListActionId (state, payload) {
      state.userListActionId = payload
    }
  },
  actions: {
    loginUser ({commit, dispatch}, {phone, password}) {
      let post = {
        data: {
          phone: phone,
          password: password
        }
      }

      post.url = '/admin/user/auth'

      dispatch('apiPost', post)
        .then((data) => {
          Vue.cookie.set('accessToken', data.access_token, 30)
          commit('setAccessToken', data.access_token)
          commit('setUser', data.user)
        })
        .catch((error) => {
          dispatch('logoutUser')
          throw error
        })
    },
    async autoLoginUser ({commit, dispatch}, {accessToken}) {
      const url = '/admin/user/self/info?access_token=' + accessToken
      let data = await dispatch('apiGet', url)
        .catch((error) => {
          dispatch('logoutUser')
          throw error
        })

      Vue.cookie.set('accessToken', accessToken, 30)
      commit('setAccessToken', accessToken)
      commit('setUser', data.user)

      return data
    },
    async passwordResetUser ({commit, dispatch}, {phone}) {
      let post = {
        data: {
          phone: phone
        }
      }

      post.url = '/admin/user/recovery/send'

      dispatch('apiPost', post)
        .then((data) => {
          commit('setSmsCodeToken', data.sms_code_token)
        })
        .catch((error) => {
          throw error
        })
    },
    async passwordResetValidateUser ({commit, dispatch}, {newPassword, smsCode}) {
      let post = {
        data: {
          sms_code_token: this.getters.smsCodeToken,
          code: smsCode,
          new_password: newPassword
        }
      }

      post.url = '/admin/user/recovery/confirm'

      dispatch('apiPost', post)
        .then((data) => {
          Vue.cookie.set('accessToken', data.access_token, 30)
          commit('setAccessToken', data.access_token)
          commit('setUser', data.user)
        })
        .catch((error) => {
          dispatch('logoutUser')
          throw error
        })
    },
    async logoutUser ({commit}) {
      Vue.cookie.delete('accessToken')
      commit('setUser', null)
      commit('setAccessToken', null)
    },
    getUserList ({commit, dispatch}, {mode, offset, limit, search, userGroupId, branchId}) {
      let searchFilter = typeof search !== 'undefined' && search !== null ? '&q=' + search : ''
      let userGroupIdFilter = typeof userGroupId !== 'undefined' && userGroupId !== null ? '&user_group_id=' + userGroupId : ''
      let branchIdFilter = typeof branchId !== 'undefined' && branchId !== null ? '&branch_id=' + branchId : ''
      const url = '/admin/user/list?access_token=' + this.getters.accessToken + '&mode=' + mode + '&offset=' + offset + '&limit=' + limit + searchFilter + userGroupIdFilter + branchIdFilter
      let userListActionId = this.getters.userListActionId + 1
      commit('setUserListActionId', userListActionId)
      dispatch('apiGet', url)
        .then((data) => {
          commit('setUserList', {data: data.user_list, userListActionId: userListActionId})
          commit('setUserTotalCount', {data: data.total_count, userListActionId: userListActionId})
        })
        .catch((error) => {
          throw error
        })
    },
    getUserSingle ({commit, dispatch}, {id}) {
      commit('setUserSingle', null)
      const url = '/admin/user/' + id + '/info?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setUserSingle', data.user)
        })
        .catch((error) => {
          throw error
        })
    },
    deleteUser ({commit, dispatch}, {id}) {
      let post = {
        data: {
          id: id
        }
      }

      post.url = '/admin/user/' + id + '/remove?access_token=' + this.getters.accessToken
      dispatch('apiPost', post)
        .then((data) => {
          commit('setSuccess', 'Пользователь удален успешно')
        })
        .catch((error) => {
          throw error
        })
    },
    activeUser ({commit, dispatch}, {id}) {
      let post = {
        data: {
          id: id
        }
      }

      post.url = '/admin/user/' + id + '/activate?access_token=' + this.getters.accessToken
      dispatch('apiPost', post)
        .then((data) => {
          commit('setSuccess', 'Пользователь активирован успешно')
        })
        .catch((error) => {
          throw error
        })
    },
    async createUser ({commit, dispatch}, user) {
      let post = {
        data: {
          last_name: user.surname,
          first_name: user.firstName,
          phone: user.phone,
          user_group_id: user.userGroupId
        }
      }

      if (user.patronymic !== null || user.patronymic !== '') {
        post.data.patronymic = user.patronymic
      }
      if (user.email !== null || user.email !== '') {
        post.data.email = user.email
      }
      if (user.avatarId !== null && typeof user.avatarId !== 'undefined') {
        post.data.photo_id = user.avatarId
      } else {
        post.data.photo_id = 0
      }
      if (user.branchId !== null && typeof user.branchId !== 'undefined') {
        post.data.branch_id = user.branchId
      }
      if (user.filialId !== null && typeof user.filialId !== 'undefined') {
        post.data.filial_id = user.filialId
      }
      if (user.pointIdList !== null && typeof user.pointIdList !== 'undefined') {
        post.data.point_id_list = user.pointIdList
      }

      let returnData = null
      if (user.id === null) {
        post.url = '/admin/user/add?access_token=' + this.getters.accessToken
        await dispatch('apiPost', post)
          .then((data) => {
            commit('setSuccess', 'Пользователь создан успешно')
            returnData = data
          })
          .catch((error) => {
            throw error
          })
      } else {
        post.id = user.id
        post.url = '/admin/user/' + user.id + '/update?access_token=' + this.getters.accessToken

        await dispatch('apiPost', post)
          .then((data) => {
            commit('setSuccess', 'Пользователь изменен успешно')
            returnData = data
          })
          .catch((error) => {
            throw error
          })
      }
      return returnData
    },
    async selfUpdateUser ({commit, dispatch}, user) {
      let post = {
        data: {
          last_name: user.surname,
          first_name: user.firstName
        }
      }

      if (user.patronymic !== null || user.patronymic !== '') {
        post.data.patronymic = user.patronymic
      }
      if (user.email !== null || user.email !== '') {
        post.data.email = user.email
      }
      if (user.avatarId !== null && typeof user.avatarId !== 'undefined') {
        post.data.photo_id = user.avatarId
      } else {
        post.data.photo_id = 0
      }

      let returnData = null
      post.id = user.id
      post.url = '/admin/user/self/update?access_token=' + this.getters.accessToken

      await dispatch('apiPost', post)
        .then((data) => {
          commit('setSuccess', 'Данные изменены успешно')
          commit('setUser', data.user)
          returnData = data
        })
        .catch((error) => {
          throw error
        })

      return returnData
    },
    async countersUser ({commit, dispatch}) {
      const url = '/admin/user/counters?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setPointLogistics', data.point_logistics)
          commit('setPointSecurity', data.point_security)
        })
        .catch((error) => {
          throw error
        })
    }
  },
  getters: {
    user (state) {
      return state.user
    },
    accessToken (state) {
      return state.accessToken
    },
    smsCodeToken (state) {
      return state.smsCodeToken
    },
    isUserLoggedIn (state) {
      return state.user !== null
    },
    userList (state) {
      return state.userList
    },
    userTotalCount (state) {
      return state.userTotalCount
    },
    userSingle (state) {
      return state.userSingle
    },
    pointLogistics (state) {
      return state.pointLogistics
    },
    pointSecurity (state) {
      return state.pointSecurity
    },
    userListActionId (state) {
      return state.userListActionId
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user.js